import { z } from 'zod';

const UUIDSchema = z.string().uuid();

export const AuditLogSchema = z.object({
  id: UUIDSchema.optional(),
  database_id: UUIDSchema,
  database_name: z.string().optional(),
  user_id: UUIDSchema,
  user_name: z.string(),
  updated_at: z.string().datetime().optional(),
  message: z.string(),
  log_level: z.number().optional(),
});
export type IAuditLog = z.infer<typeof AuditLogSchema>;

export const AuditLogItemSchema = z.object({
  id: UUIDSchema.optional(),
  update_id: UUIDSchema,
  entity_id: UUIDSchema.optional().nullable(),
  product_id: UUIDSchema.optional().nullable(),
  display_name: z.string().optional().nullable(),
  message: z.string().optional().nullable(),
});
export type IAuditLogItem = z.infer<typeof AuditLogItemSchema>;

// Combined audit log with items for API responses
export const AuditLogWithItemsSchema = z.object({
  id: UUIDSchema,
  database_id: UUIDSchema,
  database_name: z.string().optional(),
  user_id: UUIDSchema,
  user_name: z.string(),
  updated_at: z.string().datetime(),
  message: z.string(),
  log_level: z.number().optional(),
  affected_items: z.array(AuditLogItemSchema).optional(),
});
export type IAuditLogWithItems = z.infer<typeof AuditLogWithItemsSchema>;

export type IAuditPagination = {
  totalItems: number;
  totalPages: number;
  currentPage: number;
  limit: number;
  offset: number;
};

export type IAuditLogPageResponse = {
  data: IAuditLogWithItems[];
  pagination: IAuditPagination;
};

export type IAuditLogDatabaseFilters = {
  startDate?: string;
  endDate?: string;
  actions?: string[];
  search?: string;
};

export const EMPTY_AUDIT_LOG_DATABASE_FILTERS: IAuditLogDatabaseFilters = {};

export const hasActiveAuditLogFilters = (
  filters: IAuditLogDatabaseFilters,
): boolean =>
  Boolean(
    filters.startDate ||
      filters.endDate ||
      (filters.actions && filters.actions.length > 0) ||
      filters.search,
  );
